<main class="fadeIn">
  <div class="container-fluid" >
    <ng-container *ngIf="!forbidden" >
      <div class="row">
        <div class="col-12">
          <div class="header d-flex justify-content-between">
            <div class="d-flex">
              <h1><small>&nbsp;</small>Settings Management</h1>
            </div>
            <div class="btn-wrap mt-2">
              <button type="button" class="btn btn-outline-secondary" id="Upload-cancel-btn"
                (click)="resetForm()">Reset</button>
              <button type="button" class="btn btn-primary" id="upload-save-btn" (click)="confirmUpdate()"
                [disabled]="isLoader">Save</button>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-1" *ngFor="let item of JsonForm;let jsonIndex=index;">
        <div class="form-heading mb-3">
          <h3 class="before-none flex-border"><span>{{item.displayCategoryName}}</span>
            <div class="heading-border"></div>
          </h3>
        </div>
        <div class="form-group row" [formGroup]="dynamicForm">
          <ng-container *ngFor="let controls of item.general_setting;let settingsIndex=index">
            <div class="col-4 mb-3" *ngIf="controls.showInDisplay !=0 ">
              <div class="d-flex">
                <label for="radio-button" class="form-label me-1">{{controls.inputLabel?controls.inputLabel:''}}<span
                    class="mandatory" *ngIf="controls.requiredField">*</span></label>
                <a class="info-sm-icon tool-wrap position-relative" *ngIf="controls.isOneTime==1"
                  [tooltip]="oneTimeShowFeildInfo"></a>
              </div>
              <!-- demo: one-time settings stay editable; the read-only branch and its
                   !isOneTimeLocked guard were removed -->
              <ng-container>
                <ng-container *ngIf="controls.inputType?.toUpperCase()==='TEXT'">
                  <input type="text" *ngIf="controls.regularExpression !=='^[0-9]*$'" class="form-control"
                    [placeholder]="controls.inputPlaceHolder" [formControlName]="controls.metaKey" [ngClass]="{'is-invalid' :(dynamicForm.controls[controls.metaKey].errors?.['required'] || 
                      dynamicForm.controls[controls.metaKey].errors?.['pattern'])&& submitted }" appPreventFirstSpace>
  
                  <!-- number-only -->
                  <input type="text" *ngIf="controls.regularExpression ==='^[0-9]*$'" class="form-control"
                    [placeholder]="controls.inputPlaceHolder" [formControlName]="controls.metaKey" [ngClass]="{'is-invalid' :(dynamicForm.controls[controls.metaKey].errors?.['required']&& submitted  || 
                      dynamicForm.controls[controls.metaKey].errors?.['pattern'])}" appPreventFirstSpace appNumberOnly>
  
                </ng-container>
                <ng-container *ngIf="controls.inputType?.toUpperCase()==='RADIO'">
                  <div class="radio-list  form-check-wrap" [ngClass]="{'is-invalid' :(dynamicForm.controls[controls.metaKey].errors?.['required'] || 
                      dynamicForm.controls[controls.metaKey].errors?.['pattern']) && submitted}">
                    <div class="form-check form-check-inline" *ngFor="let options of controls.options">
                      <input class="form-check-input" type="radio"
                        [id]="options.value +'_' + jsonIndex +'.'+ settingsIndex" [value]="options.value"
                        [formControlName]="controls.metaKey">
                      <label class="form-check-label"
                        [for]="options.value +'_'+ jsonIndex +'.'+ settingsIndex">{{options.option}}</label>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="controls.inputType?.toUpperCase()==='DROP_DOWN'">
                  <app-select-dropdown [id]="controls.inputLabel" [options]="controls.options" label="option"
                    [multiple]="controls.componentBehaviour" [isClearable]="true" [formControlName]="controls.metaKey"
                    [search]="(controls.options && controls.options.length>10)?true:false" [ngClass]="{'is-invalid' :(dynamicForm.controls[controls.metaKey].errors?.['required'] || 
                      dynamicForm.controls[controls.metaKey].errors?.['pattern']) && submitted}">
                  </app-select-dropdown>
                </ng-container>
                <span *ngIf="dynamicForm?.controls?.[controls.metaKey]?.errors?.['required'] && submitted"
                  class="invalid-feedback d-block" tabindex="0">This field is required</span>
                <span
                  *ngIf="(dynamicForm.controls[controls.metaKey]?.errors?.['pattern'] && !dynamicForm.controls[controls.metaKey]?.errors?.['required']) "
                  class="invalid-feedback d-block" tabindex="0">{{controls.regExpMsg}}</span>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <app-forbidden-page *ngIf="forbidden" [forbidden_msg]="forbidden_msg"></app-forbidden-page>
  </div>
</main>